import { render, staticRenderFns } from "./Chats.html?vue&type=template&id=27bd7d74&scoped=true&"
import script from "./Chats.js?vue&type=script&lang=js&"
export * from "./Chats.js?vue&type=script&lang=js&"
import style0 from "./Chats.vue?vue&type=style&index=0&id=27bd7d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd7d74",
  null
  
)

export default component.exports